module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAVpJREFUOE/llNFxgzAMhi3MHiUbcNjvhUkKkzSZJHQS6LvNsUHSPTBqlLNzhhg3aR/LCweWP1v6pR9Y5JFS7hHxlTFWMsbOl3ePiJ/DMLRb2yC0IKUsEfFIawDwMc8zwViSJBkivhPcGFON43j97z93QAvrAOCglNqvN+R5nqVpWiPiGwA0Sqk+ChRC4BbM3yiEoAxKrfVuE2iDMq11FastrdFNOecdIh78mi5SFkKc1gGPiOZfYA1EY8wuVOyYeH7aN6ATQ2sdVD4EtGmf/Ev8EyAAVK4f/5Qy1dX27T2wKIoaAI7PiOKAiNi4XgSnrlPxN0C790w9DNTMZADTNLWP9p/fQtQ69M05J9MoCdgxxujnYsh/Gr3AOllcD557vKyC6BAKWntfbQ9fWNfFeb7InTanwrOxm4JOuNh4RsfMlYNqTLe35tpqrZunHNsFe+W4ujSBQ6brw78BZSn8u8tHI7kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warningIcon.png
// module id = MccX
// module chunks = 76